module.exports = __webpack_public_path__ + "static/media/horizontal_logo.d3e760f0.png";